







import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import { apiService, Interfaces, AppConstants } from "../../core/Export";

@Component({
  components: {}
})
export default class CompleteDetailsPage extends Vue {
  email: string = "";
  codeToCompleteDetails: string = "";
  errors: Array<any> = new Array<any>();

  constructor() {
    super();
  }

  created() {
    let params = this.$route.params;
    this.email = params.email;
    this.codeToCompleteDetails = params.guid;

    if (this.email && this.codeToCompleteDetails) {
      this.getRequestDetailsCodeToCompleteDetails();
    }
  }

  getRequestDetailsCodeToCompleteDetails() {
    this.errors = [];
    this.appEnv.isBusy = true;
    apiService
      .post(
        "Request/GetRequestDetailsCodeToCompleteDetails",{codeToCompleteDetails:this.codeToCompleteDetails,email:this.email}
      )
      .then(res => {
        let response = res.response as Interfaces.ICallResult;
        if (response && response.isSuccess) {
          apiService.setHeaders(res.token, "", "",this.appEnv.authority);
          store.commit("updateTRequestModel", response.result);
          this.appEnv.canViewRequestRouteRedPage = true;
          this.appEnv.isCompleteDetails = true;
          this.$router.push({
            name: AppConstants.Routes.RedRoute,
            query: { isContinue: "true" }
          });
        } else {
          this.errors = response.msgs.errors;
        }
        this.appEnv.isBusy = false;
      })
      .catch(err => {
        this.appEnv.isBusy = false;
      });
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
